import { Component, Input, TemplateRef } from '@angular/core';

@Component({
    selector: 'cv-admin-budget-title-header',
    templateUrl: './cv-admin-budget-title-header.component.html',
    styleUrls: ['./cv-admin-budget-title-header.component.scss']
})
export class CvAdminBudgetTitleHeaderComponent {

    @Input() title: string;
    @Input() btnTemplate: TemplateRef<any>;

}
